import styled from "styled-components";
// import { colors } from './../../styles';

const CircleCall = styled.div`
  width: 43px;
  height: 43px;
  border-radius: 50px;
  background: #f5f5f5;
  text-align: center;

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
  }

  img {
    margin-top: 12px;

    @media (max-width: 768px) {
      width: 22px;
    }
  }
`;
const AddAgent = styled.div`
  font-size: 11px;
  letter-spacing: 0.22px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  color: #010101;

  p {
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    text-align: end;
    font-size: 18px;
  }
`;

const CallIconSpan = styled.span`
  font-size: 2.1rem;
  color: #ffbd5d;
  font-weight: 600;
`;
const CallIconRound = styled.div`
  color: #ffbd5d;
  align-items: center;
  border-radius: 100%;
  padding-top: 11px;
  justify-content: center;
  background-color: #f2f2f2;
`;
const AgentListBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }

  h6 {
    color: #1a1848;
    letter-spacing: 0.3px;
    font-size: 14px;
    font-weight: 400;
    width: 75%;
    margin-left: 1.5rem;
    margin-bottom: 0px;
    margin-top: 0px;

    @media (max-width: 768px) {
      font-size: 22px;
    }
  }
  span {
    font-size: 11px;
    color: #303030;
    text-align: -webkit-center;

    @media (max-width: 768px) {
      text-align: left;
      font-size: 18px;
    }
  }
  .hoverChat {
    padding: 0.2rem 0.5rem;
    &:hover {
      border: 1px solid #dbe5ed;
      background: #f9fafc;
      border-radius: 10px;
    }
  }
`;

export { CircleCall, AddAgent, AgentListBox, CallIconRound, CallIconSpan };



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/dialpad/style.js.js